import { IonChip, IonIcon, IonItem, IonLabel, IonModal, IonPopover } from "@ionic/react";
import { swapVerticalOutline } from "ionicons/icons";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSort } from "../../../store/supervisorRequiredDocuments";
import { fetchHojasDeCargo } from "../../../store/supervisorRequiredDocuments/actions/getHojasDeCargo";
import { selectSortButton } from "../../../store/supervisorRequiredDocuments/selectors/selectSort";

export const SortSelector: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const sortButton = useSelector(selectSortButton);
  const dispatch = useDispatch();
  const [popoverState, setShowPopover] = useState({
    showPopover: false,
    event: undefined,
  });
  const handleSetSort = (value: string) => {
    dispatch(setSort(value));
    dispatch(fetchHojasDeCargo());
    // setShowPopover({ showPopover: false, event: undefined });
    setShowModal(false);
  };
  return (
    <>
      <IonModal
        isOpen={showModal}
        onDidDismiss={() => setShowModal(false)}
        cssClass={"modal-fix-popover"}
      >
        {sortButton.map(({ option, value }, index) => (
          <IonItem key={index} button onClick={() => handleSetSort(value)}>
            {option}
          </IonItem>
        ))}
      </IonModal>
      {/* <IonPopover
        event={popoverState.event}
        isOpen={popoverState.showPopover}
        onDidDismiss={() => setShowPopover({ showPopover: false, event: undefined })}
      >
        {sortButton.map(({ option, value }, index) => (
          <IonItem key={index} button onClick={() => handleSetSort(value)}>
            {option}
          </IonItem>
        ))}
      </IonPopover> */}
      <IonChip
        class="ion-margin-horizontal"
        color="medium"
        outline
        onClick={(e: any) => {
          // e.persist();
          // setShowPopover({ showPopover: true, event: e });
          setShowModal(true);
        }}
      >
        <IonLabel>
          <IonIcon icon={swapVerticalOutline} slot="start" />
        </IonLabel>
      </IonChip>
    </>
  );
};
